module.exports = __webpack_public_path__ + "static/chinook-logo-63c14402163d7b0dc43017f98562795e.jpeg";